import { Component, Input, OnInit } from '@angular/core';
import { faCircleNotch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { PlaylistsService } from 'src/app/services/playlists.service';
import { ToastService } from 'src/app/services/toast.service';
import { GoToDuplicateComponent } from '../go-to-duplicate/go-to-duplicate.component';

@Component({
  selector: 'app-duplicate',
  templateUrl: './duplicate.component.html',
  styleUrls: ['./duplicate.component.scss'],
})
export class DuplicateComponent implements OnInit {
  @Input() selfModal: NgbModalRef | null = null;
  public org: any = [];
  @Input() user: any = {};
  @Input() playlistId: any = ' ';
  @Input() playlistName: string = '';

  public loading: boolean = false;
  public faCircleNorch: any = faCircleNotch;
  public faTimes = faTimes;
  constructor(
    private playlistService: PlaylistsService,
    private toastService: ToastService,
    private translate: TranslateService,
    private ngbModal: NgbModal
  ) {}

  ngOnInit(): void {
    this.getOrg();
  }
  public closeModal() {
    if (this.selfModal) this.selfModal?.close();
    else $('ngb-modal-window').click();
  }
  public getOrg() {
    this.loading = true;

    this.playlistService
      .getOrg(this.user)
      .then((result) => {
        const registered = (result.data.organizationsRegistered || []).map(
          (o: any) => ({ ...o, checked: false, is_member: true })
        );
        const notRegistered = (result.data.organizationsNotRegistered || []).map(
          (o: any) => ({ ...o, checked: false, is_member: false })
        );
        // Show all orgs; mark the ones where the admin is not yet a member
        // so the UI can warn that duplicating will add them as a member.
        this.org = [...registered, ...notRegistered];
        this.loading = false;
      })
      .catch((err: any) => {
        this.loading = false;
        console.log(err);
      });
  }

  public sendOrg() {
    let organizations = this.org
      .filter((o: any) => o.checked)
      .map((o: any) => o.id);
    let goToOrg = this.org.filter((o: any) => o.checked);

    if (organizations.length == 0) {
      this.toastService.showError(
        this.translate.instant(
          'collection:modal:duplicate:playlist:organizations:error'
        )
      );

      return;
    }

    this.loading = true;
    this.playlistService
      .sendDuplicate(this.playlistId, organizations)
      .then((result: any) => {
        this.loading = false;
        this.closeModal();
        this.toastService.showSuccess(
          this.translate.instant('collection:modal:duplicate:playlist:success')
        );
        // Backend returns { data: { organizations:[{id,slug,name,made_member,new_collection_id}] } }
        // One independent collection was created per organization.
        const payload = result && result.data ? result.data : {};
        const reported = Array.isArray(payload.organizations) ? payload.organizations : [];
        const orgsForGoTo = reported.length ? reported : goToOrg;
        this.goToDuplicate(orgsForGoTo);
      })
      .catch((err: any) => {
        this.loading = false;
        const apiMsg =
          err?.error?.message?.message ||
          err?.error?.message ||
          err?.message;
        this.toastService.showError(
          typeof apiMsg === 'string' && apiMsg
            ? apiMsg
            : this.translate.instant('collection:modal:duplicate:playlist:error')
        );
        console.error('duplicate error', err);
      });
  }

  public goToDuplicate(orgSelected: any) {
    let modalRef = this.ngbModal.open(GoToDuplicateComponent, {
      windowClass: 'default-modal video-modal',
      size: '600',
      centered: true,
    });
    // Each org carries its own new_collection_id from the backend response.
    // GoToDuplicateComponent uses org.new_collection_id when navigating.
    modalRef.componentInstance.organizations = orgSelected;
    modalRef.componentInstance.playlistId = this.playlistId;
    modalRef.componentInstance.playlistName = this.playlistName;
  }
}
